<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 mr-auto ml-auto col-md-10">
				<form class="form-horizontal" action="." method="post">
					<fieldset>
						<legend>{{ 'General information' | translate }}</legend>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">Email *</label>
							<div class="col-md-7">
								<input
									type="email"
									:class="emailError ? 'error' : ''"
									v-model="email"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="emailError">{{
								emailError
							}}</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2"
								>{{ 'Phone number' | translate }} *</label
							>
							<div class="col-md-7">
								<input
									:class="numberError ? 'error' : ''"
									type="text"
									v-model="number"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="numberError">{{
								numberError
							}}</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'First name' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="firstName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Surname' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="middleName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Last name' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="lastName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Date of birth' | translate
							}}</label>
							<div class="col-md-7 date-group">
								<datepicker v-model="birthDay" :format="format"></datepicker>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2"
								>{{ 'Password' | translate }} *</label
							>
							<div class="col-md-7">
								<input
									:class="passwordError || detailError ? 'error' : ''"
									type="text"
									v-model="password"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="detailError">{{
								detailError
							}}</label>
							<label
								class="col-12 text-right text-danger"
								v-if="passwordError"
								>{{ passwordError }}</label
							>
						</div>
					</fieldset>
					<fieldset>
						<legend>{{ 'Additional information' | translate }}</legend>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Region' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="region" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Passport' | translate
							}}</label>
							<div class="col-md-7">
								<textarea v-model="passport" class="form-control"></textarea>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Id code' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="idCode" class="form-control" />
							</div>
						</div>
						<div v-if="myRole !== 'franchise'" class="row form-group">
							<label class="col-md-3 offset-md-2"
								>{{ 'Franchise' | translate }} *</label
							>
							<div class="col-md-7">
								<v-select
									:class="franchiseError ? 'error' : ''"
									:on-change="changeFranchise"
									:options="franchiseList"
								></v-select>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="franchiseError"
								>{{ franchiseError }}</label
							>
						</div>
						<div class="row form-group checkbox">
							<label class="offset-md-2">
								<input type="checkbox" v-model="isEmailSubscribed" />{{
									'With email newsletter' | translate
								}}
							</label>
						</div>
					</fieldset>
					<div v-if="myRole === 'super franchise'" class="row form-group">
						<label class="col-md-3 offset-md-2">{{
							'Comment' | translate
						}}</label>
						<div class="col-md-7">
							<textarea
								v-model="comments"
								class="form-control"
								rows="3"
							></textarea>
						</div>
					</div>
					<div class="text-center">
						<input
							@click.prevent="createProfile"
							type="submit"
							:value="'Create' | translate"
							class="btn btn-primary"
						/>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

export default {
	name: 'teacher-add',
	data() {
		return {
			number: '',
			franchiseList: [],
			franchise: '',
			email: '',
			firstName: '',
			lastName: '',
			middleName: '',
			format: 'dd/MM/yyyy',
			birthDay: null,
			region: '',
			comments: '',
			passport: '',
			isEmailSubscribed: false,
			idCode: '',
			password: '',
			emailError: '',
			numberError: '',
			passwordError: '',
			franchiseError: '',
			detailError: '',
		}
	},
	components: {
		vSelect,
		Datepicker,
	},
	computed: {
		myRole() {
			return this.$store.state.role
		},
	},
	methods: {
		createProfile() {
			let error = false
			this.emailError = ''
			this.franchiseError = ''
			this.numberError = ''
			this.passwordError = ''
			this.detailError = ''

			if (this.email === '') {
				this.emailError = this.$t('Field required')
				error = true
			}

			if (this.number === '') {
				this.numberError = this.$t('Field required')
				error = true
			}

			if (this.password === '') {
				this.passwordError = this.$t('Field required')
				error = true
			}

			if (this.franchise === '') {
				this.franchiseError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let birthday = null
			if (this.birthDay !== null) {
				birthday = this.birthDay.toISOString().slice(0, 10)
			}
			this.axios({
				method: 'post',
				url: 'users/user',
				data: {
					phone_number: this.number,
					email: this.email,
					first_name: this.firstName,
					middle_name: this.middleName,
					last_name: this.lastName,
					birthday: birthday,
					role: 'teacher',
					region: this.region,
					passport: this.passport,
					tax_id: this.idCode,
					is_email_subscribed: this.isEmailSubscribed,
					comments: this.comments,
					password: this.password,
					parent: this.franchise,
				},
			})
				.then(data => {
					this.$router.push({
						name: 'Dashboard List',
						params: { role: 'teacher' },
					})
				})
				.catch(error => {
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.detailError = this.$t(error.response.data.detail[0])
					}
				})
		},
		changeFranchise(val) {
			this.franchise = val.value
		},
	},
	beforeMount() {
		if (this.$store.state.myProfile.role === 'franchise') {
			this.franchise = this.$store.state.myProfile.id
		} else {
			this.axios({
				method: 'get',
				url: 'users?role=franchise',
			}).then(response => {
				let franchiseArray = response.data
				for (var i = 0; i < franchiseArray.length; i++) {
					let franchise = {
						value: franchiseArray[i].id,
						label:
							franchiseArray[i].last_name +
							' ' +
							franchiseArray[i].first_name +
							' ' +
							franchiseArray[i].middle_name,
					}
					this.franchiseList.push(franchise)
				}
			})
		}
	},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropdown.v-select.searchable {
	background-color: #fff;
}

textarea {
	height: 150px;
}
</style>
